/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum JsonType {
  Object = 'Object',
  Array = 'Array',
  Process = 'Process',
  Workflow = 'Workflow',
  FormLayout = 'FormLayout',
  FormSchema = 'FormSchema',
  Audit = 'Audit'
}
